import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { CONTACT } from "../../lib/data";

export const FloatingButtons = () => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 1.8, duration: 0.6 }}
    className="fixed bottom-6 right-5 z-40 flex flex-col gap-3 md:right-8"
    data-testid="floating-actions"
  >
    <a
      href={CONTACT.phoneHref}
      aria-label="Call LendX"
      data-testid="floating-call-btn"
      className="flex h-12 w-12 items-center justify-center rounded-full border border-gray-200 bg-white text-gold-deep shadow-[0_8px_30px_rgba(16,20,24,0.15)] transition-transform duration-300 hover:scale-110"
    >
      <Phone size={19} />
    </a>
    <a
      href={CONTACT.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp LendX"
      data-testid="floating-whatsapp-btn"
      className="flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgba(37,211,102,0.35)] transition-transform duration-300 hover:scale-110"
    >
      <MessageCircle size={20} />
    </a>
  </motion.div>
);
